/* eslint-disable @typescript-eslint/naming-convention */
export enum SortingTypeEnum {
	Ascending = 'asc',
	Descending = 'desc'
}

//todo: move this entities from here

export class SortingInfo {
	public direction: SortingTypeEnum;
	public column: string;
}
